if (!window.customElements.get('rewards-points-panel')) {
  const APP_PROXY_API_PREFIX = '/apps/api-hamm';
  class RewardsPointsPanel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buildSection();
      this.addAffinityTab();

      this.pointsValue = this.querySelector('[data-rewards-points-value]');
      this.credit = this.querySelector('[data-rewards-points-credit]');
      this.progress = this.querySelector('[data-rewards-points-progress]');
      this.message = this.querySelector('[data-rewards-points-message]');
      this.redeemButton = this.querySelector('[data-rewards-points-redeem]');

      this.getPoints();
      this.redeemButton.addEventListener('click', () => this.redeemPoints());
    }

    addAffinityTab() {
      const affinityNav = document.querySelector('[data-collection][role="tablist"]');
      const affinityNavButtons = affinityNav?.querySelectorAll('div');
      const affinityNavButtonClasses = affinityNavButtons?.[1]?.getAttribute('class');
      const linkAlreadyExists = affinityNav.querySelector('[data-redeem-points-button]');

      if (!affinityNav || !affinityNavButtons.length || !affinityNavButtonClasses || linkAlreadyExists) return;

      const newButton = document.createElement('a');

      newButton.setAttribute('class', affinityNavButtonClasses);
      newButton.setAttribute('href', '#rewards-points-panel');
      newButton.setAttribute('role', 'tab');
      newButton.setAttribute('aria-selected', 'false');
      newButton.setAttribute('data-redeem-points-button', '');
      newButton.innerText = window.ehs.strings.rewards.pointsPanel.redeemTab;
      affinityNav.appendChild(newButton);

      this.setAttribute('id', 'rewards-points-panel');
      this.classList.add('scroll-m-25');
    }

    buildSection() {
      this.innerHTML = `
        <div class="${window.location.href.indexOf('/tools/recurring') >= 0 ? 'w-[calc(100%+40px)] -ml-5 px-5 lg:px-6 pt-5.25 pb-6 lg:py-6 bg-white lg:ml-0 lg:w-full lg:rounded-2xl' : 'block max-w-190 mt-8 mx-auto p-6 rounded-xl border border-base-neutral-300 bg-white'}">
          <h2 class="heading-md mb-2">
            ${window.ehs.strings.rewards.pointsPanel.heading}
          </h2>

          <p class="text-base mb-5">
            ${window.ehs.strings.rewards.pointsPanel.content}
          </p>

          <div class="flex flex-col md:flex-row gap-4">
            <div class="w-full">
              <div>
                <p class="accent-base mb-2">
                  ${window.ehs.strings.rewards.pointsPanel.pointsLabel}
                </p>

                <div class="flex items-center gap-2">
                  <strong class="heading-md" data-rewards-points-value>--</strong>
                  <p class="text-sm" data-rewards-points-credit></p>
                </div>
              </div>

              <div class="h-2.5 rounded-full bg-base-neutral-200 overflow-hidden mt-4" aria-hidden="true">
                <div class="w-0 h-full rounded-full bg-ocean-waters-500 transition-all" data-rewards-points-progress></div>
              </div>

              <p class="text-sm mt-3" data-rewards-points-message>
                ${window.ehs.strings.rewards.pointsPanel.loading}
              </p>
            </div>

            <button class="button button--primary max-h-11" disabled data-rewards-points-redeem>
              ${window.ehs.strings.rewards.pointsPanel.redeemPoints}
            </button>
          </div>
        </div>
      `;
    }

    getPoints() {
      this.waitForStore(30, 100)
        .then(function (store) {
          return store.waitForReady(30, 100);
        })
        .then((store) => {
          if (typeof store.fetchPointsValue === 'function') {
            return store.fetchPointsValue();
          }
          return store.fetch().then(function (payload) {
            if (typeof store.extractPoints === 'function') {
              return store.extractPoints(payload);
            }
            return null;
          });
        })
        .then((points) => {
          this.renderPoints(points);
        })
        .catch(() => {
          this.renderPoints(0);
        });
    }

    redeemPoints() {
      this.redeemButton.setAttribute('disabled', true);

      fetch(`${APP_PROXY_API_PREFIX}/antavo/redeem`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((blob) => blob.json())
        .then((response) => {
          this.renderPoints(0);
          document.dispatchEvent(new Event('redeemPoints'));
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    renderPoints(points) {
      const minPoints = window.ehs.rewards.minPointsToRedeem || 1000;
      const progressPercent = Math.max(0, Math.min(100, (points / minPoints) * 100));

      this.pointsValue.textContent = points + ' Pts';
      this.credit.textContent = '(' + this.formatCredit(points) + ' in credit)';
      this.progress.style.width = progressPercent + '%';

      if (points === 0) {
        this.message.textContent = window.ehs.strings.rewards.pointsPanel.noRewardsToRedeem;

        this.redeemButton.setAttribute('disabled', true);

        return;
      }

      if (points < minPoints) {
        this.message.textContent = window.ehs.strings.rewards.pointsPanel.noRewardsToRedeem
          .replace('[points]', (minPoints - points).toLocaleString())
          .replace('[min_points]', minPoints.toLocaleString());

        this.redeemButton.setAttribute('disabled', true);

        return;
      }

      this.message.textContent = window.ehs.strings.rewards.pointsPanel.reachedRedemptionMin;

      this.redeemButton.removeAttribute('disabled');
    }

    waitForStore(maxAttempts, delayMs) {
      return new Promise(function (resolve, reject) {
        let attempts = 0;

        function check() {
          const store = window.AntavoPointsStore;

          if (store && typeof store.waitForReady === 'function') {
            resolve(store);
            return;
          }

          attempts += 1;
          if (attempts >= maxAttempts) {
            reject(new Error('AntavoPointsStore unavailable'));
            return;
          }

          setTimeout(check, delayMs);
        }

        check();
      });
    }

    formatCredit(value) {
      return '$' + (Number(value) / 100).toFixed(2);
    }
  }

  window.customElements.define('rewards-points-panel', RewardsPointsPanel);
}
